import axios from "axios"
import { OptimizedEvent, OptimizedEventResponse } from "types/optimizedEvent"

/**
 * Fetches optimized event data for the event page, excluding unnecessary data
 * @param eventId - The ID of the event to fetch
 * @returns Optimized event data with only the fields needed for the event page
 */
export default async function fetchEventOptimized(
    eventId: string
): Promise<OptimizedEventResponse> {
    const url = `${process.env.NEXT_PUBLIC_API_URL_V2}events/${eventId}`

    const response = await axios.get(url)
    return response.data
}
